import React from "react";
import { Layout, Menu } from "antd";
import MiCompAPI from "../../../util/api";
import Compliance from "./Compliance";
import ComplianceReports from "./ComplianceReports";

const { Content } = Layout;
class ComplianceTab extends React.Component {
  constructor(props) {
    super(props);
    let { Permissions, decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;

    this.state = {
      currentTab: "compliance",
    };

    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount = () => {};

  handleClick = (e) => {
    if (e.key === "compliance") {
      this.setState({
        isload: true,
      });
      setTimeout(() => {
        this.setState({
          isload: false,
        });
      }, 10);
    }
    this.setState({
      currentTab: e.key,
    });
  };

  getSelectedTabView() {
    switch (this.state.currentTab) {
      case "compliance":
        return !this.state.isload ? (
          <Compliance
            {...this.props}
            userPermandMasters={this.props.userPermandMasters}
          />
        ) : (
          ""
        );

      case "reports":
        return (
          <ComplianceReports
            {...this.props}
            userPermandMasters={this.props.userPermandMasters}
          />
        );

      default:
        return <></>;
    }
  }
  render() {
    const { decodedToken, Permissions } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    return (
      <Content>
        <div className="mi_main_div">
          <Menu
            className="mi_general_bar"
            style={{ width: "fit-content" }}
            onClick={this.handleClick}
            selectedKeys={[this.state.currentTab]}
            mode="horizontal"
          >
            <Menu.Item className="mi_menu_item" key="compliance">
              Compliance
            </Menu.Item>
            <Menu.Item className="mi_menu_item" key="reports">
              Reports
            </Menu.Item>
          </Menu>
          {this.getSelectedTabView()}
        </div>
      </Content>
    );
  }
}
export default ComplianceTab;
